import React from 'react';
import { Container, Typography, Paper } from '@mui/material';
import Seo from '../components/common/Seo';

function Terms() {
    return (
        <>
            <Seo
                title="利用規約"
                description="Room Share Matchingの利用規約について。当サービスをご利用いただく際の規約やルールを詳しく説明しています。"
                path="/terms"
                keywords="利用規約,サービス規約,Room Share Matching,ルール,ガイドライン"
            />
            <Container maxWidth="md">
                <Paper sx={{ p: 4, mt: 4, mb: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        利用規約
                    </Typography>
                    <Typography variant="body1" paragraph>
                        この利用規約（以下、「本規約」といいます。）は、ROOMSHAREが提供するサービス（以下、「本サービス」といいます。）の利用条件を定めるものです。登録ユーザーの皆さま（以下、「ユーザー」といいます。）には、本規約に従って本サービスをご利用いただきます。
                    </Typography>

                    <Typography variant="h6" sx={{ mt: 3 }}>
                        第1条（適用）
                    </Typography>
                    <Typography variant="body1" paragraph>
                        1. 本規約は、ユーザーとROOMSHAREとの間の本サービスの利用に関わる一切の関係に適用されるものとします。
                        2. ROOMSHAREは本サービスに関し、本規約のほか、ご利用にあたってのルール等、各種の定め（以下、「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。
                    </Typography>

                    <Typography variant="h6" sx={{ mt: 3 }}>
                        第2条（利用登録）
                    </Typography>
                    <Typography variant="body1" paragraph>
                        1. 本サービスにおいては、登録希望者が本規約に同意の上、ROOMSHAREの定める方法によって利用登録を申請し、ROOMSHAREがこれを承認することによって、利用登録が完了するものとします。
                        2. ROOMSHAREは、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。
                    </Typography>

                    <Typography variant="h6" sx={{ mt: 3 }}>
                        第3条（禁止事項）
                    </Typography>
                    <Typography variant="body1" paragraph>
                        ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
                        1. 法令または公序良俗に違反する行為
                        2. 犯罪行為に関連する行為
                        3. ROOMSHAREのサーバーまたはネットワークの機能を破壊したり、妨害したりする行為
                        4. 他のユーザーに関する個人情報等を収集または蓄積する行為
                        5. 他のユーザーに成りすます行為
                        6. ROOMSHAREのサービスの運営を妨害するおそれのある行為
                    </Typography>

                    <Typography variant="h6" sx={{ mt: 3 }}>
                        第4条（本サービスの提供の停止等）
                    </Typography>
                    <Typography variant="body1" paragraph>
                        1. ROOMSHAREは、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。
                        2. 本サービスにかかるコンピュータシステムの保守点検または更新を行う場合
                        3. 地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合
                    </Typography>

                    <Typography variant="h6" sx={{ mt: 3 }}>
                        第5条（利用制限および登録抹消）
                    </Typography>
                    <Typography variant="body1" paragraph>
                        1. ROOMSHAREは、ユーザーが以下のいずれかに該当する場合には、事前の通知なく、ユーザーに対して、本サービスの全部もしくは一部の利用を制限し、またはユーザーとしての登録を抹消することができるものとします。
                        2. 本規約のいずれかの条項に違反した場合
                        3. 登録事項に虚偽の事実があることが判明した場合
                    </Typography>

                    <Typography variant="h6" sx={{ mt: 3 }}>
                        第6条（免責事項）
                    </Typography>
                    <Typography variant="body1" paragraph>
                        1. ROOMSHAREの債務不履行責任は、ROOMSHAREの故意または重過失によらない場合には免責されるものとします。
                        2. ROOMSHAREは、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。
                    </Typography>

                    <Typography variant="h6" sx={{ mt: 3 }}>
                        第7条（サービス内容の変更等）
                    </Typography>
                    <Typography variant="body1" paragraph>
                        ROOMSHAREは、ユーザーに通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによってユーザーに生じた損害について一切の責任を負いません。
                    </Typography>

                    <Typography variant="h6" sx={{ mt: 3 }}>
                        第8条（利用規約の変更）
                    </Typography>
                    <Typography variant="body1" paragraph>
                        ROOMSHAREは、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。なお、本規約の変更後、本サービスの利用を開始した場合には、当該ユーザーは変更後の規約に同意したものとみなします。
                    </Typography>

                    <Typography variant="body1" sx={{ mt: 4 }} align="right">
                        2024年3月1日 制定
                    </Typography>
                </Paper>
            </Container>
        </>
    );
}

export default Terms; 